@if (transaction.attempts && transaction.attempts.length > 0) {
  <ap-panel *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'>
    <ap-panel-content>
      <div class='form-horizontal form-label-left'>
        <div class='row payment-attempts-container'>
          <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.TITLE' | translate }}</span>
          <div class='col-sm-12 col-md-12 col-xs-12'>
            <table mat-table #paymentAttemptsTable [dataSource]='transaction.attempts' id='datatable' class='table table-hover table-bordered table-fixed no-footer' role='grid' aria-describedby='datatable_info'>
              <!-- NUMBER -->
              <ng-container matColumnDef='{{ paymentAttemptColumns[0] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.LIST.COLUMNS.' + paymentAttemptColumns[0] | translate }}</th>
                <td mat-cell *matCellDef='let attempt'>{{ attempt.sequenceOrder | noData }}</td>
              </ng-container>
              <!-- STATUS MODIFICATION DATE -->
              <ng-container matColumnDef='{{ paymentAttemptColumns[1] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.LIST.COLUMNS.' + paymentAttemptColumns[1] | translate }}</th>
                <td mat-cell *matCellDef='let attempt'>{{ attempt.statusDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</td>
              </ng-container>
              <!-- STATUS -->
              <ng-container matColumnDef='{{ paymentAttemptColumns[2] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.LIST.COLUMNS.' + paymentAttemptColumns[2] | translate }}</th>
                <td mat-cell *matCellDef='let attempt'>
                  <status-label type='TRANSACTIONS.STATUS' [status]='PaymentStatus.FAILED'></status-label>
                </td>
              </ng-container>
              <!-- STATUS DETAILS -->
              <ng-container matColumnDef='{{ paymentAttemptColumns[3] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.LIST.COLUMNS.' + paymentAttemptColumns[3] | translate }}</th>
                <td mat-cell *matCellDef='let attempt'>{{ attempt.statusDetail | noData }}</td>
              </ng-container>
              <!-- TRANSACTION ID -->
              <ng-container matColumnDef='{{ paymentAttemptColumns[4] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.PAYMENT_ATTEMPTS.LIST.COLUMNS.' + paymentAttemptColumns[4] | translate }}</th>
                <td mat-cell *matCellDef='let attempt'>{{ attempt.transactionId | noData }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef='paymentAttemptColumns'></tr>
              <tr mat-row *matRowDef='let row; columns: paymentAttemptColumns;' role='row' class='odd'></tr>
            </table>
          </div>
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
